import type React from 'react';
import { type ModalContentProps } from '../state';
import {
  DemoModal,
  EditMatchModal,
  EditCompetitionModal,
  EditLogoModal,
  ConfirmModal,
  UploadLogoModal,
} from './modals';

const Noop = () => null;

const MODALS: Record<string, React.FC<ModalContentProps>> = {
  demo: DemoModal,
  editMatch: EditMatchModal,
  editCompetition: EditCompetitionModal,
  editLogo: EditLogoModal,
  confirm: ConfirmModal,
  uploadLogo: UploadLogoModal,
};

export const getModalContent = (
  modalType: string | null,
): React.FC<ModalContentProps> => MODALS[modalType || ''] || Noop;
